import {
  Router,
  Route,
  Switch,
  Link,
  Redirect,
  useLocation,
  useParams,
  useRouteMatch,
  useHistory,
  Prompt,
  matchPath,
} from 'react-router-dom';

export {
  Route,
  Router,
  Switch,
  Link,
  Redirect,
  useLocation,
  useParams,
  useRouteMatch,
  useHistory,
  Prompt,
  matchPath,
};
